import { WebWorkerMessageHandler } from './web-worker-message-handler.model';

export class WebWorkerMessageHandlerService {
  private _handlers: { [messageName: string]: WebWorkerMessageHandler } = {};

  /**
   * Registers a message handler
   * @param messageName The name of the message to associate with the handler.
   * @param handler The reference to the handler function.
   */
  registerHandler(messageName: string, handler: WebWorkerMessageHandler): void {
    this._handlers[messageName] = handler;
  }

  /**
   * Handles a message
   * @param messageName The name of the message to handle.
   * @param payload The optional payload of the message.
   */
  handleMessage(messageName: string, payload?: any, postMessage?: any): void {
    const handler = this._handlers[messageName];

    if (!!handler) {
      handler.processMessage(payload, postMessage);
    }
  }
}
